// Feature gating based on the domain the app was served from.
//
// The webapp is deployed to multiple hosts from the same codebase:
//   - thebackroom420.ca            → public production
//   - staging.thebackroom420.ca    → staging (preview before go-live)
//   - localhost                    → local dev
//
// Reading `window.location.hostname` at call time lets one build behave
// differently per host without a separate build flag. Keep the production
// host list here as the single source of truth.

const PRODUCTION_HOSTS = new Set<string>([
  'thebackroom420.ca',
  'www.thebackroom420.ca',
]);

/** True when the app is being served from the public production domain. */
export const isProductionSite = (): boolean =>
  typeof window !== 'undefined' && PRODUCTION_HOSTS.has(window.location.hostname);

/**
 * NEWS (the nav tab and the home-page "From the shop" section) is hidden on
 * production and shown everywhere else, so it can be previewed/edited on
 * staging before it goes live.
 */
export const newsEnabled = (): boolean => !isProductionSite();
